import { videoCreatorEdit } from '../VideoCreatorEditPage/reducer/reducer';
import { videoCreatorList } from '../VideoCreatorTemplatesListPage/reducer';

export const videoCreator = {
    videoCreatorEdit,
    videoCreatorList
};
